module.exports = __webpack_public_path__ + "img/ME_Logo.da317364.jpg";